// обрезать строку с многоточием при привышении заданного количества символом visibleLength
// до выноса называлась ellipsis
export const truncate = (string: string | undefined, visibleLength: number) => {
    if (!string) {
        return '';
    }

    return string.length > visibleLength && visibleLength !== 0
        ? `${string.slice(0, visibleLength).trim()}...`
        : string;
};
